import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { ConfigProvider } from "antd";
import '@ant-design/v5-patch-for-react-19';
import { themeProps } from "@alphascriptsolutions/client-core";
import App from "./App";

const rootElement: HTMLElement | null = document.getElementById("feedbackSupport");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(
    <FluentProvider theme={webLightTheme}>
      <ConfigProvider theme={themeProps}>
        <App />
      </ConfigProvider>
    </FluentProvider>
  );
});
